  <template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="vehicle_delivery"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="vehicleForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Kendaraan Listing"
          addButton="Tambah Kendaraan"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Kendaraan Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Kendaraan</h3>
          </div>

          <b-form id="vehicleForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Kendaraan">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.vehicleForm.name.$model"
                      :state="!$v.vehicleForm.name.$invalid"
                      required
                      placeholder="Nama Kendaraan"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Kendaraan harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.vehicleForm.description.$model"
                      :state="!$v.vehicleForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.vehicleForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "vehicle_delivery",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vehicle_delivery: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        { key: "name", label: "Nama Kendaraan", sortable: true },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "text-center width-80" }
      ],
      vehicleForm: masterInterfaces.vehicle_delivery,
      isEdit: false
    };
  },
  validations: {
    vehicleForm: {
      name: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getVehicle();
    },
    getVehicle: function() {
      this.axios
        .get("web/master/vehicle_delivery/all/")
        .then(response => {
          this.vehicle_delivery = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.vehicleForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.vehicle_delivery) {
        masterInterfaces.vehicle_delivery[a] = null;
      }
      this.vehicleForm = masterInterfaces.vehicle_delivery;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah kendaraan ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/vehicle_delivery/edit/", this.vehicleForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah kendaraan Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, "Ubah kendaraan");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan kendaraan ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/vehicle_delivery/add/", this.vehicleForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah kendaraan Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah kendaraan Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, "Tambah kendaraan");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  